<template>
<div style="width:100%;display:flex;flex-wrap:wrap;">
    <InterfaceField v-for="(field, index) in fields" :field="field" :record="record" :settings="{editing:false}" :element=field :key="index"
        @change="fieldChanged"  
        @input="fieldInput"
        @button="buttonClicked"
    />
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import InterfaceField from '../builder/InterfaceField'
import NiceData from '../data/NiceData';

export default {
    data() {
        return {
        
        }
    },

    components: {
        InterfaceField
    },
    
    props: {
        settings: Object,
        fields: Array,
        record: Object,
        recordRef: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        /* eg: changes = {
            name: xxxxx,
            value: xxxx,
            field: Object,
        } */
        fieldChanged(changes) {
            console.log('AdvancedPanel > fieldChanged > changes ',changes)
            NiceData.saveField(this.recordRef.child(changes.name), changes.value)
            this.$emit('field-change', changes)
        },
        
        fieldInput(newVal) {
            console.log('input', newVal)
        },

        buttonClicked(field) {
            this.$emit('button', field.name, this.record)
        }
    },

    created() {
        
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// AdvancedPanel.vue?573bd0c0